import React, { useEffect, useRef } from 'react';
import './intro.css';
import { ReactTyped } from 'react-typed';

const SERVICES = [
  'Wedding', 'Pre-Wedding', 'Engagement', 'Birthday',
  'Baby Shower', 'Fashion', 'Drone', 'Product',
];


const Intro = () => {
  const bgRef  = useRef(null);
  const heroRef = useRef(null);

  /* Subtle parallax on bg */
  useEffect(() => {
    const onScroll = () => {
      if (!bgRef.current) return;
      const y = window.scrollY;
      bgRef.current.style.transform = `translateY(${y * 0.35}px) scale(1.08)`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section id="intro" ref={heroRef}>

      {/* ── BG LAYERS ── */}
      <div className="intro-bg" ref={bgRef} />
      <div className="intro-overlay-base" />
      <div className="intro-overlay-vignette" />
      {/* Diagonal colour sweep */}
      <div className="intro-overlay-sweep" />

      {/* ── FLOATING BOKEH ── */}
      <div className="intro-bokeh" aria-hidden="true">
        {[...Array(10)].map((_, i) => (
          <span key={i} className={`ib ib-${i + 1}`} />
        ))}
      </div>

      {/* ── CONTENT ── */}
      <div className="intro-content">

        {/* Eyebrow */}
        <p className="intro-eyebrow">Est. 2017 · Surat, Gujarat</p>

        {/* Main headline */}
        <h1 className="intro-headline">
          <span className="intro-headline-line intro-line-1">We Are</span>
          <span className="intro-headline-line intro-line-2">Shree Photos Films</span>
        </h1>

        {/* Typed profession */}
        <div className="intro-typed-wrap">
          <span className="intro-typed-prefix">Capturing </span>
          <ReactTyped
            className="intro-typed"
            strings={[
              'Engagements ✦',
              'Pre-Weddings ✦',
              'Weddings ✦',
              'Baby Showers ✦',
              'Newborns ✦',
              'Birthdays ✦',
              'Architecture ✦',
              'Products ✦',
              'Drone Shots ✦',
              'Fashion ✦',
              'Modelling ✦',
            ]}
            typeSpeed={90}
            backSpeed={35}
            loop
            cursorChar="|"
            showCursor
          />
        </div>

        {/* Tagline */}
        <p className="intro-tagline">
          Turning your precious moments into timeless memories — one frame at a time.
        </p>

        {/* Service pills */}
        <div className="intro-pills" aria-label="Services">
          {SERVICES.map((s) => (
            <span key={s} className="intro-pill">{s}</span>
          ))}
        </div>

        {/* CTA buttons */}
        <div className="intro-cta-row">
          <a href="#Contact" className="intro-btn intro-btn--primary">
            Book Your Event
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
          <a href="#Gallery" className="intro-btn intro-btn--ghost">
            View Gallery
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
            </svg>
          </a>
        </div>
      </div>

      {/* ── SCROLL INDICATOR ── */}
      <div className="intro-scroll-hint" aria-hidden="true">
        <span className="scroll-label"></span>
        <div className="scroll-track">
          <div className="scroll-dot" />
        </div>
      </div>

      {/* ── BOTTOM WAVE ── */}
      <div className="intro-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#FFF8F0"/>
        </svg>
      </div>

    </section>
  );
};

export default Intro;